var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _client, _pollInterval, _verbose;
import fetch from 'isomorphic-unfetch';
import { Client, createRequest as createRequestUrql, } from '@urql/core';
import { pipe, subscribe } from 'wonka';
import { ErrorConnection, ErrorUnexpectedResult } from '@1hive/connect-core';
// Average block time is about 13 seconds on the 2020-08-14
// See https://etherscan.io/chart/blocktime
const POLL_INTERVAL_DEFAULT = 13 * 1000;
// Make every operation type a query, until GraphQL subscriptions get added again.
function createRequest(query, args) {
    if (query.definitions) {
        query = {
            ...query,
            definitions: query.definitions.map((definition) => ({
                ...definition,
                operation: 'query',
            })),
        };
    }
    return createRequestUrql(query, args);
}
export default class GraphQLWrapper {
    constructor(subgraphUrl, options = {}) {
        var _a, _b;
        _client.set(this, void 0);
        _pollInterval.set(this, void 0);
        _verbose.set(this, void 0);
        if (typeof options === 'boolean') {
            console.warn('GraphQLWrapper: please use `new GraphQLWrapper(url, { verbose })` rather than `new GraphQLWrapper(url, verbose)`.');
            options = { verbose: options };
        }
        options = options;
        __classPrivateFieldSet(this, _verbose, (_a = options.verbose) !== null && _a !== void 0 ? _a : false);
        __classPrivateFieldSet(this, _pollInterval, (_b = options.pollInterval) !== null && _b !== void 0 ? _b : POLL_INTERVAL_DEFAULT);
        __classPrivateFieldSet(this, _client, new Client({ maskTypename: true, url: subgraphUrl, fetch }));
    }
    close() {
        // Do nothing for now.
        // Will be used when GraphQL subscriptions will be added again.
    }
    subscribeToQuery(query, args = {}, callback) {
        const request = createRequest(query, args);
        return pipe(__classPrivateFieldGet(this, _client).executeQuery(request, {
            pollInterval: __classPrivateFieldGet(this, _pollInterval),
            requestPolicy: 'cache-and-network',
        }), subscribe((result) => {
            if (__classPrivateFieldGet(this, _verbose)) {
                console.log(this.describeQueryResult(result));
            }
            if (result.error) {
                callback(new Error('Error performing subscription.\n' +
                    `${result.error.name}: ${result.error.message} \n` +
                    this.describeQueryResult(result)));
                return;
            }
            callback(null, result);
        }));
    }
    subscribeToQueryWithParser(query, args = {}, callback, parser) {
        return this.subscribeToQuery(query, args, async (error, result) => {
            var _a, _b;
            try {
                if (error || (result === null || result === void 0 ? void 0 : result.error)) {
                    throw new ErrorConnection(result
                        ? 'Error performing subscription.\n' +
                            `${(_a = result === null || result === void 0 ? void 0 : result.error) === null || _a === void 0 ? void 0 : _a.name}: ${(_b = result === null || result === void 0 ? void 0 : result.error) === null || _b === void 0 ? void 0 : _b.message}\n` +
                            this.describeQueryResult(result)
                        : undefined);
                }
                callback(null, await this.parseQueryResult(parser, result));
            }
            catch (error) {
                callback(error);
            }
        });
    }
    async performQuery(query, args = {}) {
        const result = await __classPrivateFieldGet(this, _client).query(query, args).toPromise();
        if (__classPrivateFieldGet(this, _verbose)) {
            console.log(this.describeQueryResult(result));
        }
        if (result.error) {
            throw new ErrorConnection(this.describeQueryResultError(result) + this.describeQueryResult(result));
        }
        return result;
    }
    async performQueryWithParser(query, args = {}, parser) {
        const result = await this.performQuery(query, args);
        return this.parseQueryResult(parser, result);
    }
    async parseQueryResult(parser, result) {
        if (result.error) {
            throw new ErrorUnexpectedResult();
        }
        return parser(result);
    }
    describeQueryResultError(result) {
        if (!result.error) {
            return '';
        }
        return `${result.error.name}: ${result.error.message}\n\n`;
    }
    describeQueryResult(result) {
        var _a;
        const queryStr = (_a = result.operation.query.loc) === null || _a === void 0 ? void 0 : _a.source.body;
        const dataStr = JSON.stringify(result.data, null, 2);
        const argsStr = JSON.stringify(result.operation.variables, null, 2);
        const subgraphUrl = result.operation.context.url;
        return (`Subgraph: ${subgraphUrl}\n\n` +
            `Arguments: ${argsStr}\n\n` +
            `Query: ${queryStr}\n\n` +
            `Returned data: ${dataStr}\n\n`);
    }
}
_client = new WeakMap(), _pollInterval = new WeakMap(), _verbose = new WeakMap();
//# sourceMappingURL=GraphQLWrapper.js.map